<template>
	<div class="khpj">
		<div class="khpjContent">
			<myTableSearch :isOperate="true" :operateWidth="250" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="12" ref="tableRef" dataRow="rows">
				<template slot="signStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.signStatus === 1 ? '#20C980FF' : '#FFC851FF'
					}">
						{{ scope.row.signStatus === 1 ? '已签到' : '未签到' }}
					</span>
				</template>
				<template slot="tool">
					<div class="toolbar-container">
						<div class="toolbar-left">
							<div class="tool-btn" @click="handleRefresh" title="刷新">
								<img :src="refreshIcon" alt="刷新" class="toolbar-icon">
							</div>
						</div>
						<div class="toolbar-right">
							<div class="action-btn" :class="{ disabled: downloadTemplateLoading }" @click="downloadTemplateLoading || handleDownloadTemplate()">
								<i v-if="downloadTemplateLoading" class="el-icon-loading"></i>
								<span>{{ downloadTemplateLoading ? '下载中...' : '下载导入模板' }}</span>
							</div>
							<el-upload
								ref="uploadRef"
								action="#"
								:auto-upload="false"
								:show-file-list="false"
								:on-change="handleImportFile"
								accept=".xls,.xlsx"
								class="import-upload"
							>
								<div class="action-btn" :class="{ disabled: importLoading }">
									<i v-if="importLoading" class="el-icon-loading"></i>
									<span>{{ importLoading ? '导入中...' : '导入' }}</span>
								</div>
							</el-upload>
							<div class="action-btn add-appointment" @click="handleAddAppointment">
								<img :src="addIcon" alt="新增" class="add-icon">
								<span>新增预约</span>
							</div>
						</div>
					</div>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
					<el-button type="text" style="color:rgb(241, 74, 63);" size="small"
						@click="handleDel(scope.row)">删除</el-button>
				</template>
			</myTableSearch>
		</div>
		<!-- 新增/编辑预约 -->
		<subscribeDialog v-if="isSubscribeDialog" :isDialog="isSubscribeDialog" :isEdit="isEdit" :editData="editData"
			@handleClose="isSubscribeDialog = false" @success="handleRefresh">
		</subscribeDialog>
		<!-- 导入结果 -->
		<importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog" :resultData="importResultData"
			@handleClose="isImportResultDialog = false">
		</importResultDialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSubscribePage, deleteSubscribe, getSubscribeTemplate, importSubscribe } from '@/api/industrialInjury/subscribe'
import { getListByDictType } from '@/api/sys/dictData'
import subscribeDialog from './components/subscribeDialog.vue'
import importResultDialog from './components/importResultDialog.vue'
import arrowLeftIcon from '@/assets/pages/appointment/arrow-l.png'
import arrowRightIcon from '@/assets/pages/appointment/arrow-r.png'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import deleteIcon from '@/assets/pages/appointment/delete.png'
import addIcon from '@/assets/pages/appointment/add.png'

export default {
	components: {
		subscribeDialog,
		importResultDialog,
	},
	data() {
		return {
			arrowLeftIcon,
			arrowRightIcon,
			refreshIcon,
			deleteIcon,
			addIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isSubscribeDialog: false,//新增/编辑预约弹窗
			isEdit: false,//是否为编辑模式
			editData: {},//编辑时的数据
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			formData: [
				{
					label: '签到状态',
					type: 'select',
					key: 'signStatus',
					data: [
						{
							dictLabel: '未签到',
							dictValue: '0'
						},
						{
							dictLabel: '已签到',
							dictValue: '1'
						},
					]
				},

				{
					label: '分组',
					type: 'select',
					key: 'workInjuryCategoryCode',
					data: []
				},
				{
					label: '姓名',
					type: 'input',
					key: 'name'
				},
				{
					label: '身份证号',
					type: 'input',
					key: 'idNumber'
				},
				{
					label: '手机号',
					type: 'input',
					key: 'phone'
				},
				{
					label: '预约日期',
					type: 'daterange',
					key: 'appointmentDate',
					screen: (value) => {
						if (value && value.length === 2) {
							return {
								subscribeTimeStart: value[0],
								subscribeTimeEnd: value[1]
							}
						}
						return {}
					}
				}
			],
			tableLabel: [
				{
					prop: 'name',
					label: '姓名',
				},
				{
					prop: 'idNumber',
					label: '身份证号',
				},
				{
					prop: 'phone',
					label: '手机号',
				},
				{
					prop: 'workInjuryCategoryName',
					label: '分组',
				},
				{
					prop: 'subscribeTime',
					label: '预约时间',
				},
				{
					prop: 'signStatus',
					label: '签到状态',
				},
			],
		}
	},
	created() {
		this.loadGroupData()
	},
	methods: {
		// 获取列表数据
		queryFn(queryParams) {
			return getSubscribePage(queryParams)
		},
		// 获取分组字典
		async loadGroupData() {
			const res = await getListByDictType('industrial_injury_work_injury_category')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithGroup(res.data)
			}
		},
		// 更新分组下拉选项
		updateFormDataWithGroup(groupData) {
			if (!groupData) return

			const groupIndex = this.formData.findIndex(item => item.key === 'workInjuryCategoryCode')
			if (groupIndex !== -1) {
				this.$set(this.formData[groupIndex], 'data', groupData)
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 刷新列表
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 删除
		handleBatchDelete() {
			this.$refs.tableRef && this.$refs.tableRef.deleteAll();
		},
		// 下载导入模板
		handleDownloadTemplate() {
			this.downloadTemplateLoading = true
			getSubscribeTemplate().then(res => {
				if (res) {
					this.downloadBlobFile(res, '预约导入模板.xls');
				}
			}).finally(() => {
				this.downloadTemplateLoading = false
			})
		},
		// 导入文件
		handleImportFile(file) {
			const isExcel = file.raw.type === 'application/vnd.ms-excel' || 
				file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			const isLt10M = file.raw.size / 1024 / 1024 < 10

			if (!isExcel) {
				this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
				return
			}
			if (!isLt10M) {
				this.$message.error('文件大小不能超过 10MB！')
				return
			}

			this.importLoading = true
			const formData = new FormData()
			formData.append('file', file.raw)

			importSubscribe(formData).then(res => {
				if (res && res.code === 200) {
					this.importResultData = res.data
					this.isImportResultDialog = true
					this.handleRefresh()
				} else {
					this.$message.error(res.msg || '导入失败')
				}
			}).catch(err => {
				console.error('导入出错', err)
				this.$message.error('导入失败')
			}).finally(() => {
				this.importLoading = false
				this.$refs.uploadRef && this.$refs.uploadRef.clearFiles()
			})
		},
		// 新增预约
		handleAddAppointment() {
			this.isEdit = false
			this.editData = {}
			this.isSubscribeDialog = true
		},
		handleEdit(row) {
			this.isEdit = true
			this.editData = { ...row }
			this.isSubscribeDialog = true
		},
		// 删除预约
		handleDel(row) {
			this.$confirm('确定要删除该预约吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteSubscribe(row.id).then(res => {
					if (res && res.code === 200) {
						this.$message.success('删除成功')
						this.handleRefresh()
					} else {
						this.$message.error(res.msg || '删除失败')
					}
				}).catch(err => {
					console.error('请求出错', err)
					this.$message.error('删除失败')
				})
			}).catch(() => {})
		},
		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
	},
}
</script>

<style lang="scss" scoped>
.khpj {
	// padding: 24px 0;
	padding: 24px;

	border-radius: 5px;
	background: #ffffff;

	.khpjHead {
		width: 100%;

		.tabItem {
			display: flex;
			align-items: center;

			span {
				color: #0c7bf2;
				font-weight: bold;
				font-size: 16px;
			}

			img {
				// margin-left: 24px;
				padding-right: 8px;
				width: 24px;
				height: 24px;
			}
		}
	}

	.khpjContent {
		/deep/.myTableSearch {
			padding: 0;
		}
	}
}

.toolbar-container {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;

	.toolbar-icon {
		width: 24px;
		height: 24px;
	}

	.add-icon {
		width: 20px;
		height: 20px;
		margin-right: 6px;
	}

	.toolbar-left {
		display: flex;
		align-items: center;
		gap: 12px;

		.pagination-wrapper {
			display: flex;
			align-items: center;
			border: 1px solid #dcdfe6;
			overflow: hidden;

			.pagination-btn {
				width: 36px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #FCFCFCFF;
				cursor: pointer;
				transition: background-color 0.2s;

				&:hover {
					background: #409eff;
					color: #fff;
				}

				span {
					font-size: 14px;
					color: #606266;
				}

				&:hover span {
					color: #fff;
				}
			}

			.pagination-current {
				width: 42px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #fff;
				border-left: 1px solid #dcdfe6;
				border-right: 1px solid #dcdfe6;

				span {
					font-size: 14px;
					color: #606266;
				}
			}
		}

		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;

			.tool-btn-icon {
				font-size: 16px;
				color: #606266;
			}

			&:hover {
				border-color: #409eff;
				background: #ecf5ff;

				.tool-btn-icon {
					color: #409eff;
				}
			}
		}
	}

	.toolbar-right {
		display: flex;
		align-items: center;
		gap: 12px;

		.import-upload {
			display: inline-block;
		}

		.action-btn {
			height: 36px;
			padding: 0 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 4px;
			background: #297dee1a;
			cursor: pointer;
			transition: all 0.2s;
			font-size: 14px;
			color: #297deeff;

			&:hover {
				border-color: #409eff;
				color: #409eff;
			}

			&.disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}

			&.add-appointment {
				background: #297deeff!important;
				border-color: #409eff!important;
				color: #fff!important;

				&:hover {
					background: #66b1ff!important;
					border-color: #66b1ff!important;
				}
			}
		}
	}
}
</style>